import { render, staticRenderFns } from "./editMembers.vue?vue&type=template&id=60aa4421&scoped=true&"
import script from "./editMembers.vue?vue&type=script&lang=js&"
export * from "./editMembers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60aa4421",
  null
  
)

export default component.exports